/* GENERATED FILE - DO NOT EDIT! */
define(['underscore'], function(_) {
  return function(context) {
    var __t, __p = '',
      __j = Array.prototype.join,
      print = function() {
        __p += __j.call(arguments, '');
      };
    __p += '<div is="data-survey" class="data-survey"><h3 class="data-survey__title">Did you experience any problems with the product page you just saw on ' +
      ((__t = (context.retailerName)) == null ? '' : __t) +
      '?</h3><a class="data-survey-answer data-survey-answer__no btn btn--large btn--full-width btn--grey">everything was fine</a><hr class="data-survey-divide"><a class="data-survey-answer data-survey-answer__yes btn btn--large btn--full-width btn--grey">something went wrong</a><form class="data-survey__form" action="">';
    _.each(context.responses, function(response) {
      __p += '<label class="data-survey-response"><input class="data-survey-response__input" type="checkbox" name="response" value="' +
        ((__t = (response.value)) == null ? '' : __t) +
        '"><span class="data-survey-response__box data-survey-response__box--checkbox glyph glyph-small glyph-tick-blue"></span>' +
        ((__t = (response.text)) == null ? '' : __t) +
        '</label>';
    })
    __p += '<label class="data-survey-response data-survey-response__other"><input type="checkbox" class="data-survey-response__input data-survey-response__other-input"><span class="data-survey-response__box data-survey-response__box--checkbox glyph glyph-small glyph-tick-blue"></span>Something else</label><input class="data-survey-response__other-text" type="text" name="response_other"/><button disabled="disabled" class="data-survey__submit btn btn--large btn--full-width">Submit</button></form></div>';
    return __p;
  }
});